import {createStore} from 'vuex'

const original = createStore({
    state: {
        buckets: {
           uk:'https://documents-policy-uk.s3.eu-west-2.amazonaws.com/',
           forex:'https://documents-policy-forex.s3.us-east-2.amazonaws.com/',
           latam:'https://documents-policy-latam.s3.sa-east-1.amazonaws.com/',
           test:'https://documents-policy-teste.s3.eu-west-2.amazonaws.com/',
        }
    }
})

export default original